import { createLiveStore, useRpc } from "../lib/live-store";
import type { Asset, AssetListFilter } from "../types/api";

interface AssetListData {
  assets: Asset[];
  total: number;
}

interface AssetListExtra {
  filter: AssetListFilter;
  setFilter: (filter: AssetListFilter) => void;
}

export const useAssetListStore = createLiveStore<AssetListData, AssetListExtra>({
  topic: "assets.list",
  params: (s) => s.filter,
  onSnapshot: (data) => data as AssetListData,
  onEvent: (event, state) => {
    if (typeof event !== "object" || !event) return null;
    const evt = event as { action: string; data?: Asset; id?: number };
    switch (evt.action) {
      case "deleted":
        if (evt.id !== undefined) {
          const filtered = state.assets.filter((a) => a.asset_id !== evt.id);
          if (filtered.length < state.assets.length) {
            return { assets: filtered, total: state.total - 1 };
          }
        }
        return {};
      default:
        return null;
    }
  },
  state: (set) => ({
    assets: [],
    total: 0,
    filter: {} as AssetListFilter,
    setFilter: (filter: AssetListFilter) => set({ filter } as any),
  }),
});

export function useCreateAsset() {
  return useRpc("asset.create");
}

export function useUpdateAsset() {
  return useRpc("asset.update");
}

export function useDeleteAsset() {
  return useRpc("asset.delete");
}

export function useNextIdentifier() {
  return useRpc("asset.nextIdentifier");
}

export function useRotatePhoto() {
  return useRpc("photo.rotate");
}
